import React from 'react';

const ErrorPage = ({ onRetry }) => {
    return (
        <div className='d-flex flex-column align-items-center justify-center' style={{
            minHeight: '100vh',
            padding: '20px',
            textAlign: 'center',
            backgroundColor: '#f8f9fa'
        }}>
            <div style={{
                maxWidth: '500px',
                width: '100%',
                padding: '40px',
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
            }}>
                <div style={{
                    fontSize: '64px',
                    marginBottom: '20px',
                    color: '#dc3545'
                }}>
                    ⚠️
                </div>
                <h1 className='text-center' style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: '#333'
                }}>
                    Something went wrong
                </h1>
                <p className='text-center' style={{
                    fontSize: '16px',
                    color: '#666',
                    marginBottom: '30px',
                    lineHeight: '1.5'
                }}>
                    We're sorry, but something unexpected happened. Please try again sometime.
                </p>
                {onRetry && (
                    <button
                        className='hw-btn hw-btn--bprimary'
                        onClick={onRetry}
                        style={{
                            marginBottom: '15px'
                        }}
                    >
                        Try Again
                    </button>
                )}
                <div style={{
                    marginTop: '20px',
                    fontSize: '14px',
                    color: '#999'
                }}>
                    <button
                        onClick={() => window.location.href = '/'}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#007bff',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            fontSize: '14px'
                        }}
                    >
                        Go to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;

